import { IDayOfWeek, IWeekDayNumbers } from '../interfaces/dates';

export const days: ReadonlyArray<Capitalize<IDayOfWeek>> = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const textDays: ReadonlyArray<Capitalize<IDayOfWeek>> = ['Mon', 'Wed', 'Fri', 'Sun', 'Tue', 'Thu', 'Sat'];

/**
 * @description Takes in a day of the week as a short string and returns the number of the day of the week.
 * @example 'Mon' => 1, 'mon' => 1, 'Tue' => 2, 'tue' => 2
 */
export const dayOfWeekToNumberLookup: Record<IDayOfWeek | Capitalize<IDayOfWeek>, IWeekDayNumbers> = {
  Sun: 0,
  sun: 0,
  Mon: 1,
  mon: 1,
  Tue: 2,
  tue: 2,
  Wed: 3,
  wed: 3,
  Thu: 4,
  thu: 4,
  Fri: 5,
  fri: 5,
  Sat: 6,
  sat: 6,
};
